module.exports = __webpack_public_path__ + "img/4.20dc3f1c.png";